import { deleteHttp } from "../../common/api/apiShared";
import { useDotLegalMutation, useDotLegalQueryClient } from "../../common/hooks/dotLegalReactQuery";
import { aiChatConversationsQueryKey } from "../sidebar/AiChatSidebar.hooks";
import { useAiChatActions } from "../AiChatContext";

export function useDeleteAiChatConversationMutation() {
    const queryClient = useDotLegalQueryClient();
    const { removeScope } = useAiChatActions();
    return useDotLegalMutation<unknown, string>(
        async (id) => {
            // The shared HTTP layer turns 400 responses into a Result with errors instead of
            // throwing, so an optimistic-rollback path needs to surface those as rejections.
            const result = await deleteHttp(`/ai-chat/conversations/${id}`);
            if (result.hasErrors()) throw new Error(result.error()?.[0] ?? "delete-failed");
        },
        {
            onSuccess: (_, id) => removeScope(id),
            onSettled: () => queryClient.refetchQueries(aiChatConversationsQueryKey),
        }
    );
}
